import RoutesEnum from 'enums/routes.enum'
import LoadSessionMiddleware from 'middlewares/LoadSessionMiddleware'
import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import ForbidSubdomainMiddleware from 'middlewares/ForbidSubdomainMiddleware'

export default [
    {
        path: '/reservations/my/:type',
        name: RoutesEnum.RESERVATIONS.MY,
        view: 'reservations/MyReservations',
        middlewares: [LoadSessionMiddleware, ForbidSubdomainMiddleware],
        meta: {
            layout: 'main',
            title: 'Moje Rezervacije | Bookeraj',
            description:
                'Pregledajte svoje trenutne i prethodne rezervacije na našoj platformi. Upravljajte svojim putovanjima i planirajte buduće rezervacije.',
        },
    },
    {
        path: '/reservations/:id',
        name: RoutesEnum.RESERVATIONS.SINGLE,
        view: 'reservations/SingleReservation',
        middlewares: [LoadSessionMiddleware, RequireUserMiddleware],
        meta: {
            layout: 'main',
            title: 'Pojedinačna Rezervacija | Bookeraj',
            description:
                'Pregledajte detalje o svojoj pojedinačnoj rezervaciji na našoj platformi. Saznajte više o lokaciji, datumu, i dodatnim uslugama vezanim za ovu rezervaciju.',
        },
    },
    {
        path: '/reservations/:offerId/reschedule/:calendarEventId/:availabilityOfferId',
        name: RoutesEnum.RESERVATIONS.RESCHEDULE,
        view: 'reservations/RescheduleReservation',
        middlewares: [LoadSessionMiddleware],
        meta: {
            layout: 'main',
            title: 'Promena Termina Rezervacije | Bookeraj',
            description:
                'Izmenite datum i vreme svoje rezervacije na našoj platformi. Prilagodite svoj plan i odaberite novi termin koji vam odgovara.',
        },
    },
    {
        path: '/reservations/timeline',
        name: RoutesEnum.RESERVATIONS.TIMELINE,
        view: 'reservations/Timeline',
        middlewares: [LoadSessionMiddleware, RequireUserMiddleware],
        meta: {
            layout: 'main',
            title: 'Vremenska linija | Bookeraj',
            description:
                'Pregledajte svoje dolazeće rezervacije na našoj platformi. Upravljajte svojim putovanjima i planirajte buduće rezervacije.',
        },
    },
]
